<template>
  <div
    :class="[
      `${menu_active ? 'h-[250px]' : 'h-[43px]'} ${
        workspace_user_permission_scope && workspace_user_permission_scope !== 'admin' ? 'opacity-0 pointer-events-none' : ''
      }`
    ]"
    class="fixed z-40 overflow-visible transition-all duration-300 bg-transparent rounded-md dark:bg-dark-box-background !top-6 !right-20 border-0 flex space-x-0"
    @mouseleave="handleHoverMenu()">
    <!-- <button v-if="editModeActive" class="absolute z-20 -ml-44 btn cancel-btn" @click="setEditMode(false)">Save changes</button> -->

    <div v-if="!editModeActive">
      <Menu
        :class="[componentsActions.length ? '' : 'pointer-events-none']"
        as="div"
        class="relative inline-block px-3 mt-2 -ml-1 text-left">
        <MenuButton>
          <ModuleIcon
            :color="!componentsActions.length ? 'lightgrey' : $store.state.ui_options.theme.button_color"
            class="cursor-pointer" />
        </MenuButton>

        <!-- Sidebar user menu -->
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <!-- mx wil have to be adjusted on the "closed" variant to align with where the user picture is -->
          <MenuItems
            class="duration-200 z-10 absolute w-[300px] right-2 mt-1 mb-6 rounded-md shadow-lg bg-white dark:bg-dark-screen-background ring-1 py-2 ring-blue ring-opacity-5 focus:outline-none">
            <MenuItem v-for="item in componentsActions" :key="item.name" class="cursor-pointer text-sm">
              <div v-if="item?.divider" class="bg-gray-300 my-1 h-[1px] w-[80%] mx-auto" />
              <button
                v-else
                :disabled="item.disabled"
                :class="[
                  { 'cursor-default opacity-60 pointer-events-none': item.disabled },
                  'hover:bg-gray-100 hover:dark:bg-dark-brand-blue  text-light-body-text dark:text-dark-body-text w-full whitespace-nowrap group sm:text-sm flex items-center justify-start px-4 py-2  disabled:dark:bg-dark-transparent-brand-blue disabled:cursor-default disabled:opacity-60 transition ease-in-out duration-side-menu-transition-duration'
                ]"
                @click="item.action">
                <component
                  :is="item.icon"
                  v-if="item.icon"
                  :color="$store.state.ui.darkMode ? '#A2E0F8' : '#0a698f'"
                  class="w-5 h-5 mr-3 transition ease-in-out hover:text-dark-body-text text-common-grey duration-side-menu-transition-duration"
                  aria-hidden="true" />
                {{ item.name == $t("Edit Layout") && editModeActive ? $t("Save Layout") : item.name }}
                <span v-if="item.keyBoardShortcut" class="flex ml-auto text-sm font-semibold text-right text-gray-400">
                  <span class="">⌘</span>
                  <span class="uppercase">{{ item.keyBoardShortcut }}</span>
                </span>
              </button>
            </MenuItem>
          </MenuItems>
        </transition>
      </Menu>
    </div>
    <div v-if="editModeActive" class="p-1 ml-2 -mt-1 flex z-50 bg-transparent">
      <button
        type="button"
        :class="[
          `inline-flex items-center p-2  mr-1.5 border rounded-md  -mt-0.5 dark:border-dark-divider-border shadow-sm text-gray-500 bg-white hover:bg-red-300 focus:outline-none`
        ]"
        @click="setEditMode(false)">
        <X class="w-7 h-7" color="red" aria-hidden="true" />
      </button>

      <button
        type="button"
        :class="[
          `inline-flex items-center p-1 border rounded-md  -mt-0.5 dark:border-dark-divider-border shadow-sm text-gray-500 hover:bg-green-300 focus:outline-none`
        ]"
        @click="saveTemplate()">
        <ClipboardList class="mr-1 w-5 h-5" aria-hidden="true" /> {{ $t("Save") }}
      </button>
    </div>

    <div v-if="!editModeActive">
      <Menu :class="[quickActions.length ? '' : 'pointer-events-none']" as="div" class="relative inline-block px-3 mt-2 -ml-1 text-left">
        <MenuButton>
          <QuickActionsIcon
            :color="!quickActions.length ? 'lightgrey' : $store.state.ui_options.theme?.button_color"
            class="cursor-pointer" />
        </MenuButton>

        <!-- Sidebar user menu -->
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <!-- mx wil have to be adjusted on the "closed" variant to align with where the user picture is -->
          <MenuItems
            class="duration-200 z-10 absolute w-[300px] right-2 mt-1 mb-6 rounded-md shadow-lg bg-white dark:bg-dark-screen-background ring-1 py-2 ring-blue ring-opacity-5 focus:outline-none">
            <div v-for="item in quickActions" :key="item.name" as="li">
              <div v-if="item?.divider" class="bg-gray-300 my-1 h-[1px] w-[80%] mx-auto" />
              <button
                v-else
                :disabled="item.disabled"
                :class="[
                  { 'cursor-default opacity-60 pointer-events-none': item.disabled },
                  'hover:bg-gray-100 hover:dark:bg-dark-brand-blue  text-light-body-text dark:text-dark-body-text w-full whitespace-nowrap flex items-center px-4 py-2  disabled:dark:bg-dark-transparent-brand-blue disabled:cursor-default disabled:opacity-60 transition ease-in-out duration-side-menu-transition-duration'
                ]"
                @click="
                  () => {
                    item.action()
                    google_event('quick_action_click', {
                      event_label: 'Click on quick actions button',
                      name: item.name,
                      user_name: $store.state.auth.user.full_name,
                      user_email: $store.state.auth.user.email,
                      organization: $store.state.organization.name
                    })
                  }
                ">
                <component
                  :is="item.icon"
                  v-if="item.icon"
                  class="w-5 h-5 mr-3 transition ease-in-out justify-self-start hover:text-dark-body-text text-common-grey duration-side-menu-transition-duration"
                  aria-hidden="true" />
                {{ item.name }}
                <span v-if="item.keyBoardShortcut" class="flex mx-auto text-sm font-semibold text-center text-gray-400">
                  <span class="">⌘</span>
                  <span class="uppercase">{{ item.keyBoardShortcut }}</span>
                </span>
              </button>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </div>

  <!-- <div :class="[`${menu_active == 'help' ? `opacity-100 transition-opacity ${menu_hovered == 'help' ? 'delay-0' : 'delay-300'} duration-300  relative` : ``} `]" class="absolute gap-3 mt-3 ml-3 opacity-0">
      <div class="mb-2 cursor-pointer">
        help item 1
      </div>
      <div class="mb-2 cursor-pointer">
        help item 2
      </div>
      <div class="mb-2 cursor-pointer">
        help item 3
      </div>
      <div class="mb-2 cursor-pointer">
        help item 4
      </div>
      <div class="mb-2 cursor-pointer">
        help item 5
      </div>
    </div> -->
</template>

<script>
import { X } from "lucide-vue-next"
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import QuickActionsIcon from "@/components/shared/icons/QuickActionsIcon.vue"
import { event as google_event } from "vue-gtag-next"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { ClipboardList } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    ModuleIcon,
    X,
    QuickActionsIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ClipboardList
  },
  props: {
    quickActions: {
      type: Array,
      default: () => []
    },
    componentsActions: {
      type: Array,
      default: () => []
    },
    editModeActive: {
      type: Boolean,
      default: false
    },
    setEditMode: {
      type: Function,
      required: true
    }
  },
  emits: [],

  data() {
    return {
      google_event,
      menu_hovered: null,
      menu_hovered_calc: null,
      menu_active: null
    }
  },
  computed: {
    workspace_user_permission_scope() {
      if (this.$route.name !== "WorkspaceItem") {
        return null
      }
      return this.$store.state.ui.workspace_user_access_scope
    }
  },
  watch: {
    menu_hovered_calc() {
      setTimeout(() => {
        if (this.menu_hovered_calc) {
          this.menu_hovered = this.menu_hovered_calc
        } else {
          this.menu_hovered = null
        }
      }, 400)
    }
  },
  methods: {
    handleHoverMenu(menu_name) {
      this.menu_hovered_calc = menu_name
      if (!menu_name) {
        this.menu_active = null
      }
      if (this.menu_active) {
        this.menu_active = menu_name
      }
    },
    saveTemplate() {
      this.$emitter.emit(ALL_EMITTERS.SAVE_TEMPLATE)
    }
  }
}
</script>
